module.exports = __webpack_public_path__ + "static/media/promo_MVW_AboundLogo_mobile.4eb91457.png";